import React, { useState } from 'react';

export interface HighRiskConfirmProps {
  expectedId: string;
  confirmed: boolean;
  onConfirm: (confirmed: boolean) => void;
}

export const HighRiskConfirm: React.FC<HighRiskConfirmProps> = ({ expectedId, confirmed, onConfirm }) => {
  const [typed, setTyped] = useState('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setTyped(value);
    onConfirm(value === expectedId);
  };

  return (
    <div>
      <div style={{ fontSize: 12, color: 'var(--synapse-text-muted, #6b7280)', marginBottom: 4 }}>
        High-risk item — type <code style={{ background: '#f3f4f6', padding: '0 4px', borderRadius: 2 }}>{expectedId}</code> to confirm
      </div>
      <input
        type="text"
        value={typed}
        onChange={handleChange}
        placeholder={expectedId}
        aria-label={`Confirm by typing ${expectedId}`}
        style={{
          width: '100%',
          padding: '4px 8px',
          fontSize: 13,
          border: '1px solid var(--synapse-border, #d1d5db)',
          borderRadius: 4,
          backgroundColor: confirmed ? '#ecfdf5' : 'transparent',
        }}
      />
    </div>
  );
};
